import { MtUser } from "server/models"
import { OrderType } from "client/utils"
import { UserFilters } from "client/store"

export interface TaskParticipantList { [taskId: number]: readonly number[]}

export interface TaskParticipantState {
    taskParticipantList: TaskParticipantList

    notAssignedUsers: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
        selected: readonly number[]
    }
}

export const TASK_PARTICIPANT_LIST = "TASK_PARTICIPANT_LIST"

export const NOT_ASSIGNED_TASK_PARTICIPANT_IDS = "NOT_ASSIGNED_TASK_PARTICIPANT_IDS"
export const NOT_ASSIGNED_TASK_PARTICIPANT_SORT = "NOT_ASSIGNED_TASK_PARTICIPANT_SORT"
export const NOT_ASSIGNED_TASK_PARTICIPANT_FILTERS = "NOT_ASSIGNED_TASK_PARTICIPANT_FILTERS"
export const NOT_ASSIGNED_TASK_PARTICIPANT_SELECTED = "NOT_ASSIGNED_TASK_PARTICIPANT_SELECTED"
